export class PlaygroundStorage {
  static playgroundDatabaseName = 'criteria-playground-db'
  static fileHandlesStoreName = 'criteria-filehandles-store'
  static issuesStoreName = 'criteria-issues-store'
  static issuesRunIDIndexName = 'run.id'

  private database: IDBDatabase | null = null

  async getDatabase() {
    if (this.database) {
      return this.database
    }

    return new Promise<IDBDatabase>((resolve, reject) => {
      const request = indexedDB.open(PlaygroundStorage.playgroundDatabaseName, 2)
      request.onerror = (event) => {
        reject((event.target as IDBOpenDBRequest).error)
      }
      request.onblocked = (event) => {
        // close other tabs
      }
      request.onupgradeneeded = (event) => {
        const database = (event.target as IDBOpenDBRequest).result

        let promises: Promise<void>[] = []

        if (!database.objectStoreNames.contains(PlaygroundStorage.fileHandlesStoreName)) {
          promises.push(
            new Promise((resolve, reject) => {
              const fileHandlesStore = database.createObjectStore(PlaygroundStorage.fileHandlesStoreName, {
                autoIncrement: true
              })
              fileHandlesStore.transaction.onerror = (event) => {
                reject((event.target as IDBRequest).error)
              }
              fileHandlesStore.transaction.oncomplete = (event) => {
                resolve()
              }
            })
          )
        }

        if (!database.objectStoreNames.contains(PlaygroundStorage.issuesStoreName)) {
          promises.push(
            new Promise((resolve, reject) => {
              const issuesStore = database.createObjectStore(PlaygroundStorage.issuesStoreName, { keyPath: 'id' })
              issuesStore.transaction.onerror = (event) => {
                reject((event.target as IDBRequest).error)
              }
              issuesStore.transaction.oncomplete = (event) => {
                resolve()
              }

              issuesStore.createIndex('run.id', 'run.id', { unique: false })
            })
          )
        }

        Promise.all(promises)
          .then(() => resolve(database))
          .catch(reject)
      }
      request.onsuccess = (event) => {
        const database = (event.target as IDBOpenDBRequest).result
        resolve(database)
      }
    })
  }
}
